import { Component, ChangeDetectionStrategy, input, linkedSignal, effect } from '@angular/core';
import { NgClass } from '@angular/common';
import { SvgIconComponent } from '../../base';
import { Async, AvailableIcons, DialogVariants } from 'shared';

@Component({
  selector: 'tngh-dialog',
  standalone: true,
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SvgIconComponent, NgClass],
})
export class DialogComponent {
  readonly icon = input<AvailableIcons>();
  readonly title = input<Async<string>>('');
  readonly variant = input<DialogVariants>('primary');

  protected readonly internalIcon = linkedSignal(() => this.icon());

  constructor() {
    effect(() => {
      const value = this.variant();
      if (!this.icon() && value === 'warning') {
        this.internalIcon.set('exclamation-triangle');
      }
      if (!this.icon() && value === 'danger') {
        this.internalIcon.set('exclamation-sign');
      }
    });
  }
}
